<template>
  <section>
    <div>
      <div>
        <div class="main-containers">
          <div class="columns">
            <div class="column">
              <h3>Usuarios Relacionados</h3>
            </div>
            <div v-show="isAddUser">
              <vs-button
                  icon="add"
                  color="primary"
                  type="filled"
                  class="btn btn-primary btn-group-sm"
                  @click="openRegisterPerson()">
                Agregar usuario
              </vs-button>
            </div>
            <div v-show="isMenu">
              <vs-button
                  icon="arrow_left"
                  color="primary"
                  type="filled"
                  class="btn btn-primary btn-group-sm"
                  @click="backMenu()">
                Volver a menú
              </vs-button>
            </div>
          </div>
          <hr/>
          <div>
            <div class="is-justify-content-center card-container">
              <div class="new-card " v-for="person in personList">
                <div class="info-data active-line">
                  <label class="status-person"> Activo </label>
                </div>
                <div class="info-data active-column">
                  <div v-if="person.photo.length == 0">
                    <vs-button
                        color="primary"
                        type="filled"
                        class="btn btn-primary btn-group-sm"
                        @click="$emit('openUpdatePhoto', {'codePerson' : person.entity.code, 'action' : 'person'})">
                      Actualizar foto
                    </vs-button>

                  </div>
                  <img v-if="person.photo.length > 0"
                       :src="photo + person.photo[0]"
                       alt="user"
                       class="rounded-circle"/>
                  <div class="info-data">
                    <h4>{{ person.entity.name }}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>

export default {
  name: "ManagePerson",
  props: ['isMenu', 'isAddUser', 'personList'],
  data: () => ({
    codeplace: null,
    title: "RecentMessages",
    photo:'/api/global/download-by-code/',
    codeEntity: null
  }),
  methods: {
    backMenu() {
      this.$emit('backMenu', "person");
    },
    openRegisterPerson() {
      this.$emit('openForm', "person");
      this.isMenu = true;
    }
  }
};
</script>

<style scoped>

.status-person {
  background-color: #44D600;
  border-radius: 6px 0px;
  width: 90px;
  font-style: normal;
  font-size: 14px;
  text-align: center;
  color: white;
}

.card-container {
  display: flex;
  flex-wrap: wrap;
}

.new-card {
  width: calc(((100% + 20px) / 2) - 40px);
  margin-right: 20px;
  margin-top: 15px;
  border-radius: 6px;
  padding-bottom: 20px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
}

.new-card:nth-child(2n) {
  margin-right: 0;
}

@media (max-width: 600px) {
  .card-container {
    flex-direction: column;
  }

  .new-card {
    width: 100%;
  }
}

.info-data {
  height: 50px;
  margin-left: 15px;
}

.info-data img {
  margin-left: 15px;
  width: 70px;
  height: 70px;
}

.info-data.active-column {
  display: flex;
  height: 60px;
  margin: 5px;
  justify-content: left;
}

.info-data.active-column h4 {
  margin: 10px;
}

.info-data.active-line {
  display: flex;
  margin: 0;
  height: 28px;

}
</style>

